import React from 'react';
import { PageHeader } from '../../components/common/PageHeader';
import { ProfileTab } from './ProfileTab';

/**
 * Profile Settings Page
 * Dedicated page for partner profile management
 */
export const ProfilePage: React.FC = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Profile Settings"
        description="Manage your partner profile information and account details"
      />
      <ProfileTab />
    </div>
  );
};
